import md from '@/routes/middlewares';

import FlowDiagram from '@/views/FlowDiagram.vue';
import LegionellaControlChart from '@/views/LegionellaControlChart.vue';
import NetworkPage from '@/views/NetworkPage.vue';
import RiskAnalysis from '@/views/RiskAnalysis.vue';
import RiskAnalysisPage from '@/views/RiskAnalysisPage.vue';
import MaintenanceSchedule from '@/views/maintenanceSchedule/MaintenanceSchedule';
import TreatmentProgram from '@/views/TreatmentProgram';
import Certificate from '@/views/Certificate.vue';
import ComponentPage from '@/views/ComponentPage.vue';
import component from '@/routes/client/site/network/component';


const network = {
    path: 'networks/:networkId',
    component: NetworkPage,
    meta: {
        middlewares: [
            md.getNetworkInfo,
        ],
    },
    children: [
        component,
        // MAINTENANCE SCHEDULE
        {
            path: 'schedule',
            name: 'schedule',
            component: MaintenanceSchedule,
        },
        {
            path: 'components/:componentId',
            component: ComponentPage,
            redirect: { name: 'componentSchedule' },
            meta: {
                middlewares: [
                    md.getComponentInfo,
                ],
            },
            children: [
                {
                    path: 'schedule',
                    name: 'componentSchedule',
                    component: MaintenanceSchedule,
                },
            ],
        },
        // TREATMENT PROGRAMS
        {
            path: 'treatmentProgram',
            name: 'treatmentProgram',
            component: TreatmentProgram,
        },
        {
            path: 'components/:componentId',
            component: ComponentPage,
            redirect: { name: 'componentTreatmentProgram' },
            meta: {
                middlewares: [
                    md.getComponentInfo,
                ],
            },
            children: [
                {
                    path: 'treatmentProgram',
                    name: 'componentTreatmentProgram',
                    component: TreatmentProgram,
                },
            ],
        },
        // FLOW DIAGRAM
        {
            path: 'flowDiagram',
            name: 'flowDiagram',
            component: FlowDiagram,
        },
        {
            path: 'components/:componentId',
            component: ComponentPage,
            redirect: { name: 'componentFlowDiagram' },
            meta: {
                middlewares: [
                    md.getComponentInfo,
                ],
            },
            children: [
                {
                    path: 'flowDiagram',
                    name: 'componentFlowDiagram',
                    component: FlowDiagram,
                },
            ],
        },
        // LEGIONELLA CONTROL CHART
        {
            path: 'legionellaChart',
            name: 'legionellaChart',
            component: LegionellaControlChart,
        },
        {
            path: 'components/:componentId',
            component: ComponentPage,
            redirect: { name: 'componentLegionellaChart' },
            meta: {
                middlewares: [
                    md.getComponentInfo,
                ],
            },
            children: [
                {
                    path: 'legionellaChart',
                    name: 'componentLegionellaChart',
                    component: LegionellaControlChart,
                },
            ],
        },
        // RISK ANALYSIS
        {
            path: 'riskAnalyses/add',
            name: 'newRiskAnalysis',
            component: RiskAnalysis,
        },
        {
            path: 'riskAnalyses/:riskAnalysisId',
            component: RiskAnalysisPage,
            redirect: { name: 'riskAnalysis' },
            meta: {
                middlewares: [
                    md.getRiskAnalysisInfo,
                ],
            },
            children: [
                {
                    path: 'info',
                    name: 'riskAnalysis',
                    component: RiskAnalysis,
                },
            ],
        },
        // CERTIFICATES
        {
            path: 'certificate',
            name: 'certificate',
            component: Certificate,
        },
        {
            path: 'components/:componentId',
            component: ComponentPage,
            redirect: { name: 'componentCertificate' },
            meta: {
                middlewares: [
                    md.getComponentInfo,
                ],
            },
            children: [
                {
                    path: 'certificate',
                    name: 'componentCertificate',
                    component: Certificate,
                },
            ],
        },

    ],
};

export default network;
